// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { reviewBudgetStyles } from "@insite/content-library/Widgets/Budget/ReviewBudget";
import { xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

reviewBudgetStyles.wrapper = {};

reviewBudgetStyles.filterWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        margin: 30px -10px;
        & > div {
            flex: 0 1 50%;
            padding: 10px;
            ${xScreen("lte", "sm")} {
                flex: 1 1 100%;
            }
            &:first-child {
                flex: 1 1 100%;
                & > div {
                    max-width: 130px;
                    ${xScreen("lte", "sm")} {
                        max-width: 100%;
                    }
                }
            }
        }
    `,
};
